<template>

    <TabView ref="tabview4">

        <TabPanel>
            <template #header>
                <i class="fa fa-info-circle me-2"></i>
                <span>{{TR.info}}</span>
            </template>

            <table class="table align-items-center">
                <thead>
                    <tr>
                        <th>{{TR.name}}</th>
                        <th>{{TR.value}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in data.info_columns" :key="index">
                        <th v-html="item.title"></th>
                        <template v-if="G.privateIfNotPermission()">
                            <td v-if="item.field_type === undefined || item.field_type == 'text'">
                                <InputText type="text" v-model="parentobj['data'][item.name]" class="p-column-filter" />
                            </td>
                            <td v-else-if="item.field_type == 'numeric'">
                                <InputNumber v-model="parentobj['data'][item.name]" mode="currency" :currency="store.getCurrency()" :locale="`${store.getLang()}-${store.getLang().toUpperCase()}`" />
                            </td>
                            <td v-else-if="item.field_type == 'integer'">
                                <InputNumber v-model="parentobj['data'][item.name]" integeronly />
                            </td>
                            <td v-else-if="item.field_type == 'date'">
                                <Calendar v-model="parentobj['data'][item.name]" dateFormat="mm/dd/yy" :placeholder="'mm/dd/yyyy'"
                                    :showButtonBar="true" />
                            </td>
                            <td v-else-if="item.field_type == 'dropdown'">
                                <Dropdown
                                    v-model="selectedStatus[item.name]"
                                    @change="parentobj['data'][item.name] = selectedStatus[item.name]"
                                    :options="item.dropdown_items"
                                    optionValue="value"
                                    optionLabel="label"
                                    :placeholder="TR.select"
                                    :filter="item.dropdown_items.length > 10 ? true : false"
                                >
                                    <!-- :showClear="true" -->
                                    <template #value="slotProps">
                                        <div
                                            v-if="slotProps.value"
                                        >{{ item.dropdown_items.filter((e) => e.value == slotProps.value)[0].label }}</div>
                                        <!-- >{{ item.dropdown_items.filter((e) => e.value == slotProps.value)[0].label }}</div> -->
                                        <span v-else>{{slotProps.placeholder}}</span>
                                    </template>
                                    <template #option="slotProps">
                                        <div
                                        >{{slotProps.option.label}}</div>
                                    </template>
                                </Dropdown>
                            </td>
                            <td v-else v-html="typeof item.value === 'function' ? item.value(data.data) : data.data[item.value]"></td>
                        </template>
                        <td v-else v-html="typeof item.value === 'function' ? item.value(data.data) : data.data[item.value]"></td>
                    </tr>
                </tbody>
            </table>
        </TabPanel>

        <TabPanel>
            <template #header>
                <i class="fa fa-list me-2"></i>
                <span>{{TR.products}}</span>
            </template>
            <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi
                architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione
                voluptatem sequi nesciunt. Consectetur, adipisci velit, sed quia non numquam eius modi.</p>
        </TabPanel>

    </TabView>

</template>


<script>
    import { ref, onMounted, watchEffect } from "vue";

    import { useStore } from "@/system_modules/store";

    import { G, ajax } from "@/_common";

    import Dropdown from "primevue/dropdown";
    import InputText from "primevue/inputtext";
    import InputNumber from "primevue/inputnumber";
    import Calendar from "primevue/calendar";
    import TabView from "primevue/tabview";
    import TabPanel from "primevue/tabpanel";
    // import Button from "primevue/button";

    import { useModelWrapper } from "@/system_modules/utils/modelWrapper";

    export default {
        name: 'TabWithTable',
        props: {
            data: {
                type: Object,
                default(){
                    return null;
                }
            },
            mainref: {
                type: Object,
                default(){
                    return null;
                }
            },
        },
        components: {
            Dropdown,
            InputText,
            InputNumber,
            Calendar,
            TabView,
            TabPanel,
            // Button,
        },
        setup(props, { emit }) {
            const store = useStore();

            const TR = ref({});
            const parentobj = useModelWrapper(props, emit, "mainref");
            const selectedStatus = ref({});
            const customers = ref([]);

            const active2 = ref(0);
            const scrollableTabs = ref(Array.from({ length: 50 }, (_, i) => ({ title: `Tab ${i + 1}`, content: `Tab ${i + 1} Content` })));

            watchEffect(() => {
                TR.value = store.getTranslation();
            });



            onMounted(async () => {
                await ajax({ token: G.getClientData("DA_AUTH_TOKEN") })
                .get(store.getCustomerByUser(props.data().data.employee_id))
                .then((e) => {
                    let res = e.data || null;
                    if (res) {
                        customers.value = res.map((e) => {
                            return { value: e.id, label: e.translate[0].firstname };
                        });

                        props.data().info_columns.forEach((item, i) => {
                            if( item.field_type != 'label' ){
                                parentobj.value["data"][item.name] = typeof item.value !== 'function' ? props.data.data[item.name] : item.value(props.data.data);
                                if( item.field_type == 'dropdown' ) {
                                    if( item.name == 'customer_id' ) props.data().info_columns[i].dropdown_items = customers.value;
                                    selectedStatus.value[item.name] = props.data().data[item.name];
                                    parentobj.value["data"][item.name] = props.data().data[item.name];
                                }
                            }
                        });
                    } else {
                        // G.removeClientData("DA_AUTH_TOKEN");
                    }
                });
            });

            return {
                G,
                TR,
                store,
                parentobj,
                selectedStatus,
                active2,
                scrollableTabs,
            };
        },
    };
</script>


<style lang="scss" scoped>
    .avatar {
        color: #fff;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 50rem;
        height: 48px;
        width: 48px;
        transition: all 0.2s ease-in-out;
    }
    .table {
        width: 100%;
        margin-bottom: 1rem;
        // color: #7b809a;
        vertical-align: top;
        border-color: #f0f2f5;
    }
    .table thead th {
        // padding: .75rem 1.5rem;
        letter-spacing: 0;
        border-bottom: 1px solid #f0f2f5;
        border-bottom-color: rgb(240, 242, 245);
        text-transform: uppercase !important;
        color: var(--bs-secondary);
    }
    .table > :not(:first-child) {
        border-top: 1px solid currentColor;
    }
    .table.align-items-center td,
    .table.align-items-center th {
        vertical-align: middle;
    }
    .p-dropdown{
        width: 12rem;
    }
</style>

